import { render, staticRenderFns } from "./OrderReason.vue?vue&type=template&id=f758bb8c&scoped=true&"
import script from "./OrderReason.vue?vue&type=script&lang=js&"
export * from "./OrderReason.vue?vue&type=script&lang=js&"
import style0 from "./OrderReason.vue?vue&type=style&index=0&id=f758bb8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f758bb8c",
  null
  
)

export default component.exports